// extracted by mini-css-extract-plugin
export default {"container":"Available_Links_container__P1-LC","heading":"Available_Links_heading__7hS6T","inner":"Available_Links_inner__Ip6Nb","list":"Available_Links_list__IcSmJ"};